import React, { useState } from 'react';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import { CssBaseline, MuiThemeProvider } from '@material-ui/core';
import '../css/App.css';
import '../css/bootstrap.min.css';
import '../css/bidding.css';
import '../css/featherlight-1.7.1.min.css';
import '../css/rc-feedback.min.css';
import '../css/style.css';
import '../css/theme.css';
import Projects from './projects/Projects';
import ProjectPage from './projects/ProjectPage';
import BiddingPortalLogin from './BiddingPortalLogin';
import BiddingPortalRegister from './BiddingPortalRegister';
import PrivateRoute from '../main-components/PrivateRoute';
import BiddingNavDrawer from './bidding-drawer/BiddingNavDrawer';
import { IBidSetup } from '../api-client/autogenerated';
import getCustomTheme from '../main-components/custom-components/customTheme';
import SettingsPage from '../main-components/form-pages/SettingsPage';
import BiddingPDFViewer from './BiddingPDFViewer';
import GlobalSnackbar from '../main-components/GlobalSnackbar';
import UnsubscribePage from './unsubscribe/UnsubscribePage';
import LockedBidPage from './projects/LockedBidPage';
import GlobalNavigationBlocker from '../main-components/GlobalNavigationBlocker';

function BiddingPortal() {
  const { path } = useRouteMatch();
  const theme = getCustomTheme();

  const [currentProject, setCurrentProject] = useState<IBidSetup | undefined>(undefined);
  const [projectInfoType, setProjectInfoType] = useState<string>('');

  const handleProjectInfoType = (
    event: React.MouseEvent<HTMLDivElement, MouseEvent>,
    type: string,
  ) => {
    setProjectInfoType(type);
  };

  const loginRedirect = `${path}/login`;

  return (
    <MuiThemeProvider theme={theme}>
      <div className="bidding" style={{ minHeight: '100vh', display: 'flex' }}>
        <CssBaseline />

        <BiddingNavDrawer
          projectInfoType={projectInfoType}
          handleProjectInfoType={handleProjectInfoType}
          setProjectInfoType={setProjectInfoType}
          currentProject={currentProject}
          setCurrentProject={setCurrentProject}
        />

        <div style={{ width: '100%', overflow: 'hidden' }}>
          <Switch>
            <Route path={`${path}/login`}>
              <BiddingPortalLogin />
            </Route>

            <Route path={`${path}/register`}>
              <BiddingPortalRegister />
            </Route>

            <Route path={`${path}/pdf/:fileId`}>
              <BiddingPDFViewer />
            </Route>

            <Route path={`${path}/:id/unsubscribe`}>
              <UnsubscribePage />
            </Route>

            <Route
              path={`${path}/account`}
              render={(routeProps) => (
                <PrivateRoute {...routeProps} redirect={loginRedirect}>
                  <SettingsPage isBiddingPortal />
                </PrivateRoute>
              )}
            />

            <Route
              path={`${path}/projects`}
              render={(routeProps) => (
                <PrivateRoute {...routeProps} redirect={loginRedirect}>
                  <Projects />
                </PrivateRoute>
              )}
            />

            <Route
              path={`${path}/locked`}
              render={(routeProps) => (
                <PrivateRoute {...routeProps} redirect={loginRedirect}>
                  <LockedBidPage />
                </PrivateRoute>
              )}
            />

            <Route
              exact
              path={`${path}/:id`}
              render={(routeProps) => (
                <PrivateRoute {...routeProps} redirect={loginRedirect}>
                  <ProjectPage
                    {...routeProps}
                    setCurrentProject={setCurrentProject}
                    setProjectInfoType={setProjectInfoType}
                    projectInfoType={projectInfoType}
                  />
                </PrivateRoute>
              )}
            />

            <Route
              path={`${path}`}
              render={(routeProps) => (
                <PrivateRoute {...routeProps} redirect={loginRedirect}>
                  <Projects />
                </PrivateRoute>
              )}
            />
          </Switch>
        </div>
      </div>

      <GlobalSnackbar />
      <GlobalNavigationBlocker />
    </MuiThemeProvider>
  );
}

export default BiddingPortal;
